(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nomad-home"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const element = event.target instanceof Element ? event.target : null;
    const link = element?.closest('a[href]');
    if (!link) return;
    const destination = new URL(link.href, window.location.href);
    if (destination.origin !== window.location.origin || destination.pathname !== window.location.pathname || !destination.hash.startsWith('#nomad-')) return;
    const menu = link.closest('details[open]');
    if (!menu) return;
    const closeButton = Array.from(menu.querySelectorAll('button')).find((button) => button.getAttribute('on:click') === '/close');
    closeButton?.click();
  });

  } catch(e) { console.error(e); }
})();
})();
